/** Names of used eCommerce events in GA4 Google Analytics format. */
export enum Ga4EcommerceEvents {
	add_to_cart = 'add_to_cart',
	begin_checkout = 'begin_checkout',
	purchase = 'purchase',
	remove_from_cart = 'remove_from_cart',
	select_item = 'select_item',
	view_item = 'view_item',
	view_item_list = 'view_item_list'
}
